// 测试环境配置：如果 REACT_APP_TEST_* 未定义，则回退到 REACT_APP_*（正式环境）
// 当前配置：测试环境登录应该使用 test.erp.duobaby.net（通过代理）
const domain = process.env.BUILD_ENV === 'test'
  ? (process.env.REACT_APP_TEST_DOMAIN || process.env.REACT_APP_DOMAIN)
  : process.env.REACT_APP_DOMAIN
const userCenterDomain = process.env.BUILD_ENV === 'test'
  ? (process.env.REACT_APP_TEST_USER_CENTER_DOMAIN || process.env.REACT_APP_USER_CENTER_DOMAIN)
  : process.env.REACT_APP_USER_CENTER_DOMAIN
// 开发环境：返回空字符串，强制使用相对路径，通过 setupProxy 代理访问
// 测试/生产环境：使用环境变量配置的域名
const szMysqlDomain = process.env.NODE_ENV === 'development'
  ? '' // 开发环境使用空字符串，通过代理访问（强制使用相对路径，避免与 baseURL 冲突）
  : (process.env.BUILD_ENV === 'test'
    ? (process.env.REACT_APP_TEST_SZ_MYSQL || process.env.REACT_APP_SZ_MYSQL)
    : process.env.REACT_APP_SZ_MYSQL)

const jDomain = process.env.BUILD_ENV === 'test'
  ? (process.env.REACT_APP_TEST_J_DOMAIN || process.env.REACT_APP_J_DOMAIN)
  : process.env.REACT_APP_J_DOMAIN

// 开发环境调试：确保 szMysqlDomain 是空字符串
if (process.env.NODE_ENV === 'development' && szMysqlDomain !== '') {
  console.warn('[BasicConfig] 警告: 开发环境下 szMysqlDomain 应该是空字符串，但当前值是:', szMysqlDomain)
}

const shixinlDomain = process.env.BUILD_ENV === 'test'
  ? (process.env.REACT_APP_TEST_SHIXIN_DOMAIN || process.env.REACT_APP_SHIXIN_DOMAIN)
  : process.env.REACT_APP_SHIXIN_DOMAIN

// 根据环境返回登录 URL
// 开发环境和测试环境：使用相对路径，通过服务器端代理访问（setupProxy.js）
// 生产环境：使用完整 URL
const getLoginShixinUrl = () => {
  // 开发环境：使用相对路径，通过 setupProxy.js 代理访问
  // setupProxy.js 中 /api.php 代理到 https://test.erp.duobaby.net
  if (process.env.NODE_ENV === 'development') {
    // 如果配置了 tapi.duobaby.net，使用 /tapi 代理
    if (shixinlDomain && shixinlDomain.includes('tapi.duobaby.net')) {
      return '/tapi/api.php/Login/externalLogin'
      // return '/tapi/monitorApi.php/Login/monitorLogin'
    }
    // 开发环境使用 /api.php 代理（代理到 https://test.erp.duobaby.net）
    return '/api.php/Login/externalLogin'
  }
  
  // 测试环境：也使用相对路径，通过服务器端代理访问
  // 注意：如果测试环境是构建后的静态文件，需要服务器端配置代理（如 Nginx）
  // 代理应该指向 https://test.erp.duobaby.net（不是 test.awl.duobaby.net）
  if (process.env.BUILD_ENV === 'test') {
    // 如果配置了 tapi.duobaby.net，使用 /tapi 代理
    if (shixinlDomain && shixinlDomain.includes('tapi.duobaby.net')) {
      return '/tapi/api.php/Login/externalLogin'
    }
    // 测试环境使用 /api.php 代理（需要服务器端配置代理到 https://test.erp.duobaby.net）
    // 强制返回相对路径，避免使用 shixinlDomain 构建完整 URL
    return '/api.php/Login/externalLogin'
  }
  
  // 生产环境：使用完整 URL（https://erp.duobaby.net）
  return `${shixinlDomain || ''}/api.php/Login/externalLogin`
}

// 根据环境返回登录 URL
// 开发环境：使用相对路径，通过 setupProxy.js 代理访问
// 测试/生产环境：使用完整 URL
const getLoginUrl = () => {
  // 开发环境：使用相对路径，通过 setupProxy.js 代理访问
  if (process.env.NODE_ENV === 'development') {
    // 如果配置了 tapi.duobaby.net，使用 /tapi 代理
    if (shixinlDomain && shixinlDomain.includes('tapi.duobaby.net')) {
      return '/tapi/api.php/Login/externalLogin'
    }
    // 开发环境使用 /api.php 代理（代理到 https://test.erp.duobaby.net）
    return '/api.php/Login/externalLogin'
  }
  
  // 测试/生产环境：使用完整 URL
  // 注意：确保 shixinlDomain 中的 awl.duobaby.net 被替换为 erp.duobaby.net
  let domain = shixinlDomain || ''
  if (domain && /\.?awl\.duobaby\.net/i.test(domain)) {
    domain = domain.replace(/\.?awl\.duobaby\.net/gi, (match) => {
      return match.replace('awl', 'erp')
    })
  }
  return `${domain}/api.php/Login/externalLogin`
}

const basicConfig = {
  domain,
  userCenterDomain,
  szMysqlDomain,
  shixinlDomain,
  jDomain,
  // loginShixin:'/web.php/Common/testMinimal',
  loginShixin: getLoginShixinUrl(),
  loginUrl: `${shixinlDomain}/api.php/Login/externalLogin`, // 根据环境返回相对路径或完整 URL
  loginCodeUrl: `${userCenterDomain}/otherSystem/login`,
  amapKey: '9a770993c1ebb1199d925f4ac6ce3ab1' // 高德地图API Key
}

export default basicConfig

// http://192.168.0.10/api.php/Login/externalLogin